import formInput from '@/components/common/form-input/form-input.vue'
import formSelect from '@/components/common/form-select/form-select.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import Multiselect from 'vue-multiselect'
import { mapActions, mapState, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import messages from '@/helpers/messages'

export default {
  components: {
    formInput,
    formSelect,
    formButton,
    Multiselect
  },
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      user: {}
    }
  },
  computed: {
    ...mapState('user', ['countriesList', 'currentUser']),
    ...mapGetters('user', ['roles']),
    isOrdinaryUser: function () {
      return this.user.role !== 'superadmin'
    },
    isAllData: function () {
      const defaultCheck = Boolean(this.user.name)
      if (this.isOrdinaryUser) {
        return Boolean(defaultCheck && this.user.country.length > 0)
      } else {
        return defaultCheck
      }
    }
  },
  methods: {
    ...mapActions('user', ['updateUser', 'getUser', 'getUsers', 'getCountriesList']),
    onSaveButtonClicked: async function () {
      try {
        let user = {
          id: this.user.id,
          email: this.user.email,
          name: this.user.name,
          role: this.user.role,
          status: this.user.status,
          piAccess: this.user.pi_access
        }
        if (this.isOrdinaryUser) {
          user.country = this.user.country.map((country) => country.id)
        } else {
          user.country = []
          user.piAccess = true
        }
        await this.updateUser(user)
        this.$notify({
          text: 'User succesfully edited',
          type: 'success'
        })
      } catch (e) {
        this.$notify({
          text: 'There was an error while editing the user',
          type: 'error'
        })
      }
      this.user.edit(this.user.id)
      this.data.refresh()
    },
    onChangeUserStatus: async function (status) {
      try {
        await this.$dialog.confirm(messages.user[status])
        await this.updateUser({
          id: this.user.id,
          status
        })
      } catch (e) {
        if (e) {
          this.$notify({
            text: `There was an error while changing status to ${status}`,
            type: 'error'
          })
        }
      }
      this.user.edit(this.user.id)
      this.data.refresh()
    },
    onDeleteUser: async function () {
      try {
        await this.$dialog.confirm(messages.shouldDeleteItem)
        await this.updateUser({
          id: this.user.id,
          status: 'deleted'
        })
      } catch (e) {
        if (e) {
          this.$notify({
            text: 'There was an error while deleting the user',
            type: 'error'
          })
        }
      }
      this.user.edit(this.user.id)
      this.data.refresh()
    },
    isEmpty
  },
  async created() {
    this.getCountriesList()
    const userRes = await this.getUser({ id: this.data.id })
    this.user = Object.assign({}, this.data, userRes)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/user-management/user-edit/user-edit.js